export default "//static.tradera.net/touchweb/static/output/images/paypal.1891c35a.svg";